<template>
  <div class="user-machine-line-product jt-table">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :visible.sync="dialogUpgrade"
      width="50%"
      top="9vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
    >
      <template #title>
        <div class="title_dialog">
          {{ $t("upgrade.selectApk") }}
        </div>
      </template>
      <div style="width: 100%">

      </div>
      <el-form
        style="padding: 10px 0"
        label-position="left"
        v-loading="loading"
        :element-loading-text="$t('common.loading')"
        ref="updateVersion"
        :model="model"
        :align="'left'"
      >
    
        <el-table
          :empty-text="$t('common.noData')"
          :data="model.packages"
          @selection-change="handleSelectionChange"
          style="width: 100%"
          max-height="550"
        >
          <el-table-column :width="100" :label="$t('common.operate')" :align="'center'">
            <template slot-scope="scope">
              <el-radio :label="scope.$index" v-model="radio" @change="getCurrentRow(scope.row)" size="medium">
                V{{ scope.row.version }}
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" :label="$t('upgrade.fileName')"></el-table-column>
          <el-table-column
            :width="100"
            prop="version"
            :label="$t('upgrade.appVersion')"
          ></el-table-column>
        </el-table>

        <!-- 添加分页器 -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="currentChange"
          :current-page="model.page.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="model.page.pageSize"
          layout="total,sizes,prev,pager,next,jumper"
          :total="+model.page.total"
          style="margin-top: 10px; text-align: right"
        >
        </el-pagination>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button size="small" type="primary" :disabled="loadingForm" @click="submitForm('updateVersion')">
          {{ $t("common.definite") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "UpgradeVersion",
    props: {
      dialogUpgrade: Boolean,
      MachineNo: String,
      isOneUpdate: [Boolean, Number],
      upgradeType: [Boolean, Number],
      rowInfo: Object,
      isOneKey: Boolean
    },
    data() {
      return {
        loading: false,
        loadingForm: false,
        model: {
          packages: [],
          page: {
            type: "",
            pageSize: 20,
            pageIndex: 1,
            uId: ""
          }
        },
        selectSet: {
          id: ""
        },
        radio: "",
        pid: ""
      };
    },
    mounted() {
      this.pid = localStorage.getItem("pId");
    },
    methods: {
      // 选择信息
      getCurrentRow(val) {
        this.selectSet = val;
      },
      // 关闭弹窗
      cancel(state) {
        this.$emit("cancel", false, state);
      },
      closeDialog() {
        this.cancel("");
      },
      openDialog(fuser = 0) {
        if (fuser == 0) {
          this.model.page.uId = "";
        }
        // 从 localStorage 获取 wType 作为当前 type
        const wType = localStorage.getItem("wType") || "";
        this.model.page.type = wType;
        this.model.packages = [];
        this.model.page.pageIndex = 1;
        this.model.page.pageSize = 20;
        this.radio = "";
        this.selectSet = {};
        this.selectSet.id = "";
        this.currentChange();
      },
      currentChange(pageIndex) {
        this.loading = true;
        this.model.page.pageIndex = pageIndex || 1;

        this.$api
          .request(this.$url.Upgrade.listAppPage, this.$method.get, { ...this.model.page })
          .then(res => {
            if (res.code === 0) {
              this.model.packages = res.data.records;
              this.model.page.total = res.data.total;
              this.model.page.pageIndex = res.data.pages;
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      submitForm() {
        if (!this.selectSet.id) {
          this.$notify({
            title: this.$t("common.tip"),
            message: this.$t("upgrade.selectOne"),
            type: "error"
          });
          return false;
        }
        let equipmentNo = this.MachineNo;
        let versionId = this.selectSet.id;
        let machineNoSet = equipmentNo.split(",");
        // APP升级
        if (this.isOneKey) {
          // 一键升级
          this.$confirm(this.$t("upgrade.upgradeWarn"), this.$t("common.tip"), {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          })
            .then(() => {
              this.loadingForm = true;
              let url = this.$url.Upgrade.appVersionMore;
              let method = this.$method.post;
              this.$api
                .request(url, method, {
                  userEquipmentIds: machineNoSet,
                  apkId: versionId
                })
                .then(res => {
                  this.loadingForm = false;
                  this.cancel("APK");
                  if (res.code === 0) {
                    this.$notify({
                      title: this.$t("common.tip"),
                      message: res.msg,
                      type: "success"
                    });
                  } else {
                    this.$notify({
                      title: this.$t("common.tip"),
                      message: res.msg,
                      type: "warning"
                    });
                  }
                })
                .catch(err => {
                  this.loadingForm = false;
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: err.msg,
                    type: "error"
                  });
                });
            })
            .catch(() => {});
        } else {
          // 单个升级
          this.$confirm(this.$t("upgrade.upgradeWarn"), this.$t("common.tip"), {
            confirmButtonText: this.$t("common.definite"),
            cancelButtonText: this.$t("common.cancel"),
            type: "warning"
          })
            .then(() => {
              this.loadingForm = true;
              let url = this.$url.Upgrade.appVersion;
              let method = this.$method.post;
              this.$api
                .request(url, method, {
                  equipmentNo: equipmentNo,
                  apkId: versionId
                })
                .then(res => {
                  this.loadingForm = false;
                  this.cancel("APK");
                  if (res.code === 0) {
                    this.$notify({
                      title: this.$t("common.tip"),
                      message: res.msg,
                      type: "success"
                    });
                  } else {
                    this.$notify({
                      title: this.$t("common.tip"),
                      message: res.msg,
                      type: "warning"
                    });
                  }
                })
                .catch(err => {
                  this.loadingForm = false;
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: err.msg,
                    type: "error"
                  });
                });
            })
            .catch(() => {});
        }
      },
      handleSizeChange(val) {
        this.model.page.pageSize = val;
        this.model.page.pageIndex = 1;
        this.currentChange(1);
      }
,
      handleSelectionChange(val) {
        // Selection is handled by radio button, not checkbox
        // This handler is required by el-table but not used
      }
    }
  };
</script>

<style lang="scss">
  .el-dialog__body {
    padding: 0 20px 15px 20px !important;
  }
  .image-slot {
    width: 34px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    background-color: #f5f7fa;
    color: #909399;
    font-size: 12px;
  }
  .el-table .warning-row {
    background: #f2f6fc;
  }
  .demo .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
  }
  /*打开时文字位置设置*/
  .demo .el-switch__label--right {
    z-index: 1;
    right: -10px;
  }
  /*关闭时文字位置设置*/
  .demo .el-switch__label--left {
    z-index: 1;
    left: 34px;
  }
  /*显示文字*/
  .demo .el-switch__label.is-active {
    display: block;
  }
  .demo.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 60px !important;
    height: 28px !important;
    line-height: 28px;
    border-radius: 14px;
  }
  .user-machine-line-product .el-switch__core:after {
    width: 24px !important;
    height: 24px !important;
  }
  .user-machine-line-product .el-switch {
    height: 28px !important;
    padding-bottom: 3px;
  }
  .user-machine-line-product .el-switch.is-checked .el-switch__core::after {
    margin-left: -25px;
  }

  .user-machine-line-product .el-button--mini,
  .el-button--mini.is-round {
    padding: 8px 15px;
  }

  .title_dialog {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
  }
</style>
